import comp from "./TagLearningGoals";
export default comp;
